import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logoImage from '../assets/logo-white.png';


const AppHeader = () => (

  <AppBar>
    <Toolbar>
      <i className="material-icons appToolbar-menu">menu</i>
      <img src={logoImage} style={{height:50}} alt="logo"/>
      <h1 className="appToolbar-title">Program Voluntariat</h1>
    </Toolbar>
  </AppBar>
);




export default AppHeader;